import { FC, lazy } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import ManualPayments from './ManualPayments';
const Payouts = lazy(() => import('pages/payouts'));

const ManualPaymentsWrapper: FC = () => {
  const menuVersion = useSelector(
    (state: RootState) => state.layoutConfiguration.menuVersion
  );
  return menuVersion === 'old' ? <Payouts /> : <ManualPayments />;
};

export default ManualPaymentsWrapper;
